// eslint-disable-next-line import/no-cycle
import stripe from '@/store/modules/payment/stripe/index';

export default {
  namespaced: true,
  modules: {
    stripe,
  },
};
